import axios from "axios";

// Use environment variable for middleware URL
let middlewareURL = process.env.REACT_APP_MIDDLEWARE_URL;
// let middlewareURL = "http://127.0.0.1:7001";

axios.defaults.baseURL = middlewareURL;

export const getAccessToken = () => {
  const token = window.localStorage.getItem("accessToken");
  return token === null ? "" : token;
};

export const getRefreshToken = () => {
  const token = window.localStorage.getItem("refreshToken");
  return token === null ? "" : token;
};

export const decodeJWT = (token) => {
  if (!token || token === "") {
    throw new Error('No token provided');
  }
  
  try {
    // JWT is in the format: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid token format: JWT should have 3 parts');
    }
    
    const payloadBase64 = parts[1];
    if (!payloadBase64) {
      throw new Error('Invalid token format: Missing payload');
    }
    
    // Base64 decode (handle URL-safe encoding)
    const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeBase64(base64);
    const payload = JSON.parse(jsonPayload);
    
    return payload;
  } catch (error) {
    throw new Error('Invalid token: ' + error.message);
  }
};

// Helper function for base64 decoding
const decodeBase64 = (base64) => {
  try {
    // Try standard atob first
    return atob(base64);
  } catch (e) {
    // If atob fails, try a more robust approach
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  }
};

// This function creates a request with the access token for authenticated API calls
export const createRequest = () => {
  const token = getAccessToken();
  
  return axios.create({
    baseURL: middlewareURL,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`
    }
  });
};

// This function creates a request with the refresh token for the token refresh endpoint
export const createRefreshRequest = () => {
  const token = getRefreshToken();
  
  return axios.create({
    baseURL: middlewareURL,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`
    }
  });
};

export default axios;
